import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { useEffect, useState } from "react";
import MenuFriendlyIframe from "shared/components/menu-friendly-iframe/MenuFriendlyIframe";
import { fetchSongToolsSigninToken } from "shared/service/StrmService";

const Promotion: React.FC = () => {
  const [songToolsToken, setSongToolsToken] = useState<string>();
  useEffect(() => {
    const loadScript = (src: string, attrs: Record<string, string> = {}) =>
      new Promise<void>((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        Object.entries(attrs).forEach(([key, value]) =>
          script.setAttribute(key, value)
        );
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.body.appendChild(script);
      });

    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      var isMobile = false;
      var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
      eventer(messageEvent, function (e) { processParentEvent(e); });
    `;
    document.body.appendChild(inlineScript);

    Promise.all([
      loadScript("https://strm.songtools.io/js/wixgetcontent.js?v=1738787616"),
      loadScript(
        "https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=6706d724bb0e4c6b5a5c849b",
        {
          integrity: "sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=",
          crossorigin: "anonymous",
        }
      ),
    ]).then(() => {});

    return () => {
      document.body.removeChild(inlineScript);
    };
  }, []);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response: any = await fetchSongToolsSigninToken();

        setSongToolsToken(response);
      } catch (error) {
        console.error("Failed to fetch SongTools signin token", error);
      }
    };

    fetchToken();
  }, []);

  useEffect(() => {
    if (songToolsToken) {
      dataLayerViewedEvent({
        ...tagManagerEvent.Promotions.SONGTOOLS_WHITELABEL,
      });
    }
  }, [songToolsToken]);

  if (!songToolsToken) return null;

  return (
    <MenuFriendlyIframe>
      <iframe
        title="songtools-widget"
        id="iframeWidget"
        frameBorder="0"
        width="100%"
        height="900"
        src={`https://widgets.songtools.io/v1/CampaignTestX?app-key=CA604044B66447399364523482EC42AB&autodetect=1&jwt=${songToolsToken}`}
        style={{
          backgroundColor: "transparent",
          height: "100dvh",
          border: "0px",
          margin: "0",
          padding: "0",
          overflow: "hidden",
        }}
        allow="clipboard-write"
        scrolling="no"
      ></iframe>
    </MenuFriendlyIframe>
  );
};

export default Promotion;
